<template>
  <div
    class="col-md-12 col-xs-12 searchUser"
    v-if="
      this.getEnableAgencyCanPlayForUser === true &&
      this.isAgencyLogged === true
    "
  >
    <h4>{{ $t('playOnBehalfOfAUser') }}:</h4>
    <v-autocomplete
      v-model="userSelected"
      :items="users"
      :search-input.sync="search"
      class="autocomplete-transfer"
      item-text="userName"
      item-value="userId"
      return-object
    >
      <template v-slot:item="data">
        <template>
          <v-list-item-content>
            <v-list-item-title v-html="data.item.userName"></v-list-item-title>
            <v-list-item-subtitle
              v-html="data.item.userId"
            ></v-list-item-subtitle>
          </v-list-item-content>
        </template>
      </template>
    </v-autocomplete>

    <div class="col-md-12 col-xs-12 pt-0 pl-0 pr-0">
      <template v-if="this.userSelected != null">
        <span class="playingBehalfUser"
          >{{ $t('youArePlayingBehalfUser') }}:
        </span>
        <br />
        <!--                <span style="font-size: 13px">{{$t('userId')}}: {{this.userSelected.userId}}</span> <br>-->
        <span style="font-size: 13px"
          >{{ $t('userName') }}: {{ this.userSelected.userName }}</span
        >
        <br />
        <span style="font-size: 13px"
          >{{ $t('balance') }}:
          {{ formatPrice(this.selectedUserBalance) }}</span
        >
        <span class="refresh-balance" @click="updateSportBalance()">
          <v-icon style="font-size: 18px"> mdi-refresh </v-icon>
        </span>
      </template>
    </div>

    <div class="col-md-12 col-xs-12 pt-0 pl-0 pr-0 automaticRecharge">
      <template v-if="this.userSelected != null">
        <v-checkbox
          v-model="autoRecharge"
          :label="$t('automaticRecharge')"
          @change="updateAutoRechargeMode"
        >
        </v-checkbox>
      </template>
    </div>

    <div class="col-md-12 col-xs-12 pt-0 pl-0 pr-0" style="text-align: center">
      <v-btn
        type="button"
        @click="resetUser()"
        class="action-primary-btn"
        id="search-button"
      >
        {{ $t('generic.reset') }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import axios from 'axios'
import { getProxyAccessToken } from '@/plugins/cookie-plugins'

const AGENCY_TYPE = 4

export default {
  name: 'SearchUser',
  components: {},
  data: () => ({
    loginToSearch: null,
    userSelected: null,
    users: [],
    btnLoading: false,
    selectedUserBalance: null,
    autoRecharge: false,
  }),
  mounted() {},
  beforeDestroy() {},
  watch: {
    async userSelected(newValue, oldValue) {
      if (newValue == null) {
        await this.setUserIdOfUserToPlayBetFor(null)
        await this.setLoginOfUserToPlayBetFor(null)
        this.selectedUserBalance = null
        this.resetUser()
      } else {
        await this.setUserIdOfUserToPlayBetFor(newValue.userId)
        await this.setLoginOfUserToPlayBetFor(newValue.userName)
        //this.updateBalanceForSelectedUser();
        this.updateSportBalance()
      }
    },
  },
  computed: {
    ...mapGetters({
      getType: 'user/getType',
      getPlatformSettings: 'settings/getPlatformSettings',
      getEnableAgencyCanPlayForUser: 'settings/getEnableAgencyCanPlayForUser',
      getProxyUrl: 'settings/getProxyUrl',
    }),
    search: {
      get() {
        return this.loginToSearch
      },

      set(searchInput) {
        if (this.loginToSearch !== searchInput) {
          this.loginToSearch = searchInput
          this.searchUser()
        }
      },
    },

    isAgencyLogged: function () {
      let isAgencyLogged = false

      if (this.getType != null && this.getType === AGENCY_TYPE) {
        isAgencyLogged = true
      }
      return isAgencyLogged
    },
  },
  methods: {
    ...mapActions({
      setUserIdOfUserToPlayBetFor: 'user/setUserIdOfUserToPlayBetFor',
      setLoginOfUserToPlayBetFor: 'user/setLoginOfUserToPlayBetFor',
      fetchUserBalance: 'user/fetchUserBalance',
      fetchUserSportBalance: 'user/fetchUserSportBalance',
      setEnableAutoRecharge: 'settings/setEnableAutoRecharge',
      getUserSportBalance: 'user/getUserSportBalance',
    }),

    async resetUser() {
      this.loginToSearch = null
      this.userSelected = null
      this.users = []
      this.btnLoading = false
      this.selectedUserBalance = null
      this.autoRecharge = false
    },

    async searchUser() {
      const vm = this
      vm.btnLoading = true

      const minSearchLength = 3
      if (vm.loginToSearch && vm.loginToSearch.length >= minSearchLength) {
        try {
          const endpointUrl = this.constructEndpointUrl(vm.loginToSearch)
          const response = await this.fetchUserData(endpointUrl)
          vm.users = this.formatUserList(response.data)
        } catch (error) {
          console.error(error)
          vm.resetUser()
        } finally {
          vm.btnLoading = false
        }
      }
    },

    constructEndpointUrl(loginToSearch) {
      let endpointUrl = `${this.getPlatformSettings.sircms_endpoint}bookie/user-account/signup/admin/net/entities?likeUserName=`

      if (this.getProxyUrl != null) {
        endpointUrl = `${this.getProxyUrl}/user-account/signup/admin/net/entities?likeUserName=`
      }

      return endpointUrl + loginToSearch
    },

    async fetchUserData(url) {
      const headers = { 'content-type': 'application/json' }
      const options = { method: 'get', url, headers }

      if (this.getProxyUrl != null) {
        const accessToken = this.getToken()
        headers['Authorization'] = `Bearer ${accessToken}`
      } else {
        options.withCredentials = true
      }

      return await axios(options)
    },

    formatUserList(userList) {
      if (userList == null) {
        return [] // todo fix me
      }
      return userList.map(user => ({
        userName: user.userName,
        userId: user.userId,
        customerId: user.customerId,
      }))
    },

    getToken() {
      return getProxyAccessToken()
    },

    async updateBalanceForSelectedUser() {
      const vm = this
      if (this.userSelected != null) {
        try {
          const resp = await this.fetchUserBalance({
            customerId: this.userSelected.customerId,
            userId: this.userSelected.userId,
          })

          if (resp != null) {
            const wallets = resp.data
            wallets.forEach(function (item) {
              if (item.walletGroup.mainWallet == true) {
                vm.selectedUserBalance = item.balance
              }
            })
          }
        } catch (e) {
          console.log(e)
          vm.resetUser()
        }
      }
    },
    async updateSportBalance() {
      const vm = this
      if (this.userSelected != null) {
        try {
          const totalBalance = await this.getUserSportBalance({
            customerId: this.userSelected.customerId,
            userId: this.userSelected.userId,
          })

          this.selectedUserBalance = totalBalance
        } catch (e) {
          console.log(e)
          vm.resetUser()
        }
      }
    },
    formatPrice(value) {
      const val = (value / 1).toFixed(2)
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '')
    },
    updateAutoRechargeMode() {
      // console.log('new mode is');
      // console.log(this.autoRecharge);
      this.setEnableAutoRecharge(this.autoRecharge)
    },
  },
}
</script>

<style scoped>
.bet-console-prefix .v-list-item .v-list-item__title {
  line-height: 1;
  color: #000;
}

.bet-console-prefix .theme--dark.v-list-item .v-list-item__subtitle {
  color: #000;
}

.bet-console-prefix .v-list-item__content {
  color: #000 !important;
}

.bet-console-prefix .playingBehalfUser {
  font-size: 14px;
  color: red;
}
</style>
